<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.75 3.59375C7.00391 3.59375 3.96875 6.65625 3.96875 10.375C3.96875 14.1211 7.00391 17.1562 10.75 17.1562C14.4688 17.1562 17.5312 14.1211 17.5312 10.375C17.5312 6.65625 14.4688 3.59375 10.75 3.59375ZM14.6055 6.51953C16.6016 8.51562 16.7109 11.6328 15.043 13.7656L7.35938 6.08203C9.49219 4.41406 12.6094 4.52344 14.6055 6.51953ZM6.86719 14.2578C4.87109 12.2617 4.76172 9.14453 6.42969 7.01172L14.1133 14.6953C11.9805 16.3633 8.86328 16.2539 6.86719 14.2578Z"
        />
    </svg>
</template>
